// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ProductCategories_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/product_categories/lista
 *
 * Returns the list of active product categories.
 */
import type { ProductCategories_ListaRow } from './ProductCategories_ListaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ProductCategories_ListaResponseDados = ProductCategories_ListaRow[];

export type ProductCategories_ListaResponse = ApiResponse<ProductCategories_ListaResponseDados>;

registerResponseContract('ProductCategories_ListaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_product_category_id:           { type: 'number',  required: true },
      so_product_category_name:         { type: 'string',  required: true },
      so_product_category_franchise_id: { type: 'number',  required: true },
      so_product_category_active:       { type: 'number',  required: true },
      so_product_category_created_at:   { type: 'string',  required: false },
    },
  },
})
